import React, { useEffect, useState } from "react";
import BreadCrumpBack from "../../../components/navigator/back";
import { user_challenge_opportunity_list } from "../../user/user.api";
import "../careers/tenders.css";

function ChallengesOpportunities(props) {
  const [data, setData] = useState([]);

  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  useEffect(() => {
    user_challenge_opportunity_list().then((res) => {
      const rows = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
        ? res?.data
        : [];

      const mapped = rows
        .filter(
          (x) =>
            String(x?.status).toLowerCase() === "approved" ||
            String(x?.status) === "1"
        )
        .map((item) => ({
          ...item,
          opportunity:
            item?.market_analysis_opportunity?.opportunity ??
            item?.market_analysis_opportunity_name ??
            item?.opportunity ??
            "",
          image:
            item?.image && assetBaseUrl
              ? `${assetBaseUrl}/${String(item.image).replace(/^\//, "")}`
              : item?.image || "",
          brochure:
            item?.brochure && assetBaseUrl
              ? `${assetBaseUrl}/${String(item.brochure).replace(/^\//, "")}`
              : item?.brochure || "",
        }));

      setData(mapped);
    });
  }, []);

  const handleLink = (linkurl) => {
    if (!linkurl) return;
    const urlLower = String(linkurl).toLowerCase();
    const urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };

  return (
    <>
      <div className="container-fluid event-bg">
        <div className="row m-55">
          <h3>
            {props.state.language === "ma"
              ? "ചലഞ്ചുകളും അവസരങ്ങളും"
              : "Challenges/Opportunities"}
          </h3>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container-fluid">
        <div className="table-container overflow-auto">
          <table className="">
            {data.length > 0 ? (
              <tr className="">
                <th className="table-head">
                  {props.state.language === "ma" ? "അവസരം" : "Opportunity"}
                </th>
                <th className="table-head">
                  {props.state.language === "ma" ? "തലക്കെട്ട്" : "Title"}
                </th>
                <th className="table-head">
                  {props.state.language === "ma" ? "വിവരണം" : "Description"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "അവസാന തീയതി" : "Due Date"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ലിങ്ക്" : "Link"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ബ്രോഷർ" : "Brochure"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ചിത്രം" : "Image"}
                </th>
              </tr>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{ fontSize: "20px" }}
              >
                No Recent Postings
              </div>
            )}
            {data.map((card) => {
              return (
                <>
                  <tr>
                    <td className="m-2 text-left">
                      {card?.opportunity || "-"}
                    </td>
                    <td className="m-2 text-left">{card?.title || "-"}</td>
                    <td className="m-2 text-left">
                      {card?.description || "-"}
                    </td>
                    <td className="m-2 text-left">{card?.due_date || "-"}</td>
                    <td className="m-2 text-left">
                      {card?.site_url ? (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLink(card.site_url);
                          }}
                          className="break_link"
                        >
                          {props.state.language === "ma" ? "കാണുക" : "Open"}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="m-2 text-left">
                      {card?.brochure ? (
                        <a
                          onClick={(e) => window.open(card?.brochure, "_blank")}
                          className="break_link"
                        >
                          {props.state.language === "ma"
                            ? "ഡൗൺലോഡ്"
                            : "Download"}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="m-2 text-left">
                      {card?.image ? (
                        <img
                          src={card.image}
                          alt=""
                          style={{ width: "80px", height: "60px", objectFit: "cover" }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}

export default ChallengesOpportunities;
